import Typography from "@mui/material/Typography";
import {Box, Button, Stack} from "@mui/material";
import AddCardRoundedIcon from "@mui/icons-material/AddCardRounded";
import useRegisterQueries from "../hooks/queries/useRegisterQueries";
import useCardInfoQueries from "../hooks/queries/useCardInfoQueries";
import Loading from "./Loading";
import {useSnackbar} from "notistack";


const SubscriptionRenewal = () => {
    const {renewSubscriptionMutation, payForSubscriptionMutation} = useRegisterQueries()
    const {cardInfoGetForBusinessQuery, cardInfoChangeActiveCardMutation, cardInfoDeleteCardMutation} = useCardInfoQueries()
    const {data: cardInfos, isPending: cardInfosLoading} = cardInfoGetForBusinessQuery
    const {enqueueSnackbar} = useSnackbar()

    const payForSubscription = cardId => payForSubscriptionMutation.mutate({cardId}, {
        onSuccess: () => {
            enqueueSnackbar('Sikeres fizetés, egy pár percet igénybe vehet a fizetés feldolgozása!', {variant: 'success'});
        },
        onError: (errors) => {
            errors.forEach(err => {
                if (err.field) {
                    enqueueSnackbar(`${err.message} - ${err.field}`, {variant: 'error'});
                } else {
                    enqueueSnackbar(err.message, {variant: 'error'});
                }
            });
        },
    })

    const addCard = () => renewSubscriptionMutation.mutate({}, {
        onSuccess: response => window.location.href = response.paymentLink,
        onError: (errors) => {
            errors.forEach(err => {
                if (err.field) {
                    enqueueSnackbar(`${err.message} - ${err.field}`, {variant: 'error'});
                } else {
                    enqueueSnackbar(err.message, {variant: 'error'});
                }
            });
        },
    })

    if (cardInfosLoading || cardInfoChangeActiveCardMutation.isPending || cardInfoDeleteCardMutation.isPending || renewSubscriptionMutation.isPending) return <Loading isLoading />

    return <div className="white-card">
        <Typography variant='subtitle2'>Bankkártyák</Typography>
        <Typography variant='body2' color='#536B74' gutterBottom>
            Új kártya hozzáadása esetén időbe
            telhet míg az adatok ellenőrízve lesznek, addig az xxxx-xxxx-xxxx-xxxx számú kártyát mutatja
            a rendszer.
        </Typography>
        <Stack spacing={1} marginBottom={2}>
            {cardInfos?.map((c, i) => <Box key={`card_${i}`}>
                <Stack direction='row' spacing={2}>
                    <Stack spacing={1} className='bank-card'>
                        <Box
                            style={{
                                width: '30px',
                                height: '20px',
                                background: '#c79a00',
                                borderRadius: '5px',
                                border: '1px solid #866b00'
                            }}/>
                        <Typography variant='caption' color='#fff'>
                            {c.card_mask}
                        </Typography>
                        <Typography variant='caption' color='#fff'>
                            VALID: {c.expiry}
                        </Typography>
                    </Stack>
                    <Stack spacing={1}>
                        <Button
                            onClick={() => payForSubscription(c.id)}
                            variant='contained'>
                            Fizetés ezzel a kártyával
                        </Button>
                    </Stack>
                </Stack>
            </Box>)}
        </Stack>
        <Button
            variant='contained'
            endIcon={<AddCardRoundedIcon/>}
            onClick={addCard}>
            Kártya hozzáadása
        </Button>

    </div>
}

export default SubscriptionRenewal